<!--
 * @Description: 演讲嘉宾
 * @Author:  单珊珊
 * @Date: 2024-07-31 09:08:01
 * @LastEditTime: 2024-09-10 11:58:30
 * @LastEditors:  
-->
<template>
  <div class="main-container">
    <page-header>{{'演讲嘉宾' | dealLanguage('Speaker')}}</page-header>
    <Spin fix v-if="loading">
      <Icon type="ios-loading" size=18 class="demo-spin-icon-load"></Icon>
      <div>Loading</div>
    </Spin>
    <div class="filter-tag">
      <div class="filter-tag-item" v-for="item, index in assort_list" :key="index + 'assort'" :class="{'filter-tag-active' : item == active_assort}" @click="changeAssort(item)">{{item}}</div>
    </div>
    <div class="filter-tag">
      <div class="filter-tag-item" v-for="item, index in date_list" :key="index + 'date'" :class="{'filter-tag-active' : item == active_date}" @click="changeDate(item)">{{item}}</div>
    </div>
    <div class="flex-wrapper">
      <div class="flex-left">
        <Affix :offset-top="94" v-if="anchor_list.length > 0">
          <Anchor :affix="false" :bounds="300" :offset-top="110" :scroll-offset="80">
            <AnchorLink :href="'#' + item.id" :title="item.name" v-for="item in anchor_list" :key="item.id" />
          </Anchor>
        </Affix>
      </div>
      <div class="flex-right">
        <div class="froum-list">
          <div class="froum-wrapper" v-for="item in froum_list" :key="item.activityId" :id="item.activityId">
            <div class="froum-base">
              <p>{{item.dateName}}-{{item.activityName}}</p>
              <p><i class="iconfont">&#xe672;</i>{{item.forumPlace}}</p>
            </div>
            <div class="speakers">
              <speaker-item v-for="g_item in item.guestDtoList" :key="item.activityId + g_item.id" :itemDetail="g_item"></speaker-item>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PageHeader from '@/components/pc/pageHeader.vue'
import { mapState } from 'vuex'
import SpeakerItem from '@/components/index/speakerItem.vue'
import { getActExhibitionGuest } from '@/service/vbef'
import filter from 'js/filter'
export default {
  metaInfo() {
    return {
      title: this.language == 'zh' ? '演讲嘉宾' : 'Speaker',
    }
  },
  data() {
    return {
      // speakersList: []
      froum_list: [],
      assort_list: [filter.dealLanguage('全部分类', 'All meetings')],
      date_list: [filter.dealLanguage('全部时间', 'All time')],
      first_load: 0,
      active_assort: filter.dealLanguage('全部分类', 'All meetings'),
      active_date: filter.dealLanguage('全部时间', 'All time'),
      anchor_list: [],
      loading: false,
    }
  },
  components: {
    PageHeader,
    SpeakerItem,
  },
  computed: {
    ...mapState({
      user_key: (state) => state.user_key,
      user: (state) => state.user,
      activityId: (state) => state.activityId,
      language: (state) => state.language,
    }),
  },

  created() {
    this.getActExhibitionGuest()
  },

  mounted() {},

  methods: {
    changeAssort(item) {
      this.active_assort = item
      this.getActExhibitionGuest()
    },
    changeDate(item) {
      this.active_date = item
      this.getActExhibitionGuest()
    },
    async getActExhibitionGuest() {
      this.loading = true
      this.anchor_list = []
      let res = await getActExhibitionGuest({
        actId: this.activityId,
        assortName: (this.active_assort == '全部分类' || this.active_assort == 'All meetings') ? '' : this.active_assort,
        dateName: (this.active_date == '全部时间' || this.active_date == 'All time') ? '' : this.active_date,
        languageType: this.language == 'zh' ? 0 : 1
      })
      if (res.code == 0) {
        this.$set(this.$data, 'froum_list', res.data.activityGuests)
        this.froum_list.map((a) => {
          this.anchor_list.push({
            id: a.activityId,
            name: a.activityName,
          })
          if (a.forumPlaceJson) {
            let place = JSON.parse(a.forumPlaceJson)
            let forum = ''
            if (place.level1_show == 1 && place.place_level1) forum += place.place_level1
            if (place.level2_show == 1 && place.place_level2) forum += ' ' + place.place_level2
            if (place.level3_show == 1 && place.place_level3) forum += ' ' + place.place_level3
            this.$set(a, 'forumPlace', forum)
          } else {
            this.$set(a, 'forumPlace', '')
          }
        })
        if (this.first_load == 0) {
          this.assort_list = [...this.assort_list, ...res.data.assortNames]
          this.date_list = [...this.date_list, ...res.data.dateNames]
        }
        this.first_load = 1
      } else {
        this.$Messager.error(filter.dealLanguage(res.msg, res.enMsg || res.msg))
      }
      this.loading = false
    },
  },
  watch: {
    language(newVal,oldVal ) {
      if(newVal == 'zh') {
        this.assort_list = ['全部分类']
        this.date_list = ['全部时间']
        this.active_assort = '全部分类'
        this.active_date = '全部时间'
      } else {
        this.assort_list = ['All meetings']
        this.date_list = ['All time']
        this.active_assort = 'All meetings'
        this.active_date = 'All time'
      }
      this.first_load = 0
      this.getActExhibitionGuest()
    }
  }
}
</script>
<style lang='stylus' scoped>
@import '~styles/common-pc.styl'
.filter-tag
  display flex
  flex-wrap wrap
  margin-top 20px
  &+.filter-tag
    margin-top 0
  &-item
    height 46px
    background #FFFFFF
    border 1px solid #FA5A00
    padding 0 28px
    display flex
    justify-content center
    align-items center
    font-size 16px
    color #FA5A00
    cursor pointer
    transition all 0.5s
    margin-bottom 10px
    &:not(:last-child)
      margin-right 10px
    &:hover
      color #fff
      background #FA5A00
  &-active
    background #FA5A00
    color #fff
.froum-list
  .froum-wrapper
    margin-bottom 20px
    .froum-base
      width 100%
      height 42px
      background #80A4FF
      padding 8px 20px
      display flex
      justify-content space-between
      align-items center
      line-height 25px
      font-size 18px
      color #FFFFFF
      i
        font-size 16px
        // margin-right 14px
    .speakers
      display flex
      flex-wrap wrap
      >>> .speaker-item
        margin-top 20px
        &:not(:nth-of-type(5n))
          margin-right 30px
</style>